(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('activityResumoOcorrencias', ActivityResumoOcorrencias);

  function ActivityResumoOcorrencias() {
    return {
      restrict: 'E',
      templateUrl: 'views/propriedade/resumo-ocorrencias.html',
      controller: 'ResumoOcorrenciasCtrl',
      scope: {
        tipo: '<',
        data: '<'
      }
    };
  }

}());
